import { useCallback } from 'react';

const LS_RATED = (f: string) => `fr_rated_${f}`;
const LS_SKIP  = (f: string) => `fr_skip_${f}`;
const LS_USED  = (f: string) => `fr_used_${f}`;
const SKIP_MS  = 7 * 24 * 60 * 60 * 1000; // 7 days
const DELAY_MS = 1500;

// Module-level singleton — allows trigger from any component (even cleanup/unmount)
// to show the popup rendered at root level (FeatureRatingManager in App.tsx)
let _callback: ((feature: string) => void) | null = null;

export function registerFeatureRatingCallback(cb: (feature: string) => void): () => void {
  _callback = cb;
  return () => { _callback = null; };
}

export function markFeatureRated(feature: string): void {
  localStorage.setItem(LS_RATED(feature), '1');
}

export function markFeatureSkipped(feature: string): void {
  localStorage.setItem(LS_SKIP(feature), String(Date.now() + SKIP_MS));
}

/**
 * A pessoa USOU o recurso (analisou um prato, gerou um plano). Só quem usou
 * é perguntado: avaliar uma aba que se abriu por engano produzia nota sobre
 * nada — "you are asking me to rate something you haven't let me see".
 */
export function marcarUsoDoRecurso(feature: string): void {
  try { localStorage.setItem(LS_USED(feature), '1'); } catch { /* sem armazenamento */ }
}

export function jaUsouRecurso(feature: string): boolean {
  try { return localStorage.getItem(LS_USED(feature)) === '1'; } catch { return false; }
}

export function useFeatureRating(featureName: string) {
  const triggerRating = useCallback(() => {
    if (!jaUsouRecurso(featureName)) return;
    if (localStorage.getItem(LS_RATED(featureName))) return;
    const skipUntil = Number(localStorage.getItem(LS_SKIP(featureName)) ?? 0);
    if (Date.now() < skipUntil) return;
    setTimeout(() => {
      _callback?.(featureName);
    }, DELAY_MS);
  }, [featureName]);

  return { triggerRating };
}
